export const GET_WASH_CENTRES_REQUEST = "GET_WASH_CENTRES_REQUEST";
export const GET_WASH_CENTRES_SUCCESS = "GET_WASH_CENTRES_SUCCESS";
export const GET_WASH_CENTRES_FAILURE = "GET_WASH_CENTRES_FAILURE";


